// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skl-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.skl-panel {
  padding-top: 20px;
}

.skl-card {
  margin-bottom: 20px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}

.skl-card__body {
  padding: 20px;
}

.skl-card__body--actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.skl-table-wrap {
  border: 1px solid #edf0f2;
  border-radius: 4px;
  overflow: hidden;
}

.skl-row {
  display: grid;
  grid-template-columns: 1fr 1fr 0.8fr 1.4fr 1fr 0.8fr;
}

.skl-row--header {
  background: #f8f9fa;
}

.skl-row--data + .skl-row--data {
  border-top: 1px solid #edf0f2;
}

.skl-cell {
  display: flex;
  align-items: center;
  min-height: 56px;
  padding: 12px 16px;
}

.skl-records-stack {
  display: flex;
  flex-direction: column;
}

.skl-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 18px;
}

.skl-pagination-buttons {
  display: flex;
  gap: 4px;
}

@media (max-width: 991.98px) {
  .skl-row {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 575.98px) {
  .skl-card__body--actions,
  .skl-pagination {
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/cmdb-sync/cmdb-sync-skeleton/cmdb-sync-skeleton.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,oDAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE;IACE,gDAAA;EACF;AACF;AAEA;EACE;;IAEE,eAAA;IACA,2BAAA;IACA,SAAA;EAAF;AACF","sourcesContent":[".skl-tabs {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.skl-panel {\n  padding-top: 20px;\n}\n\n.skl-card {\n  margin-bottom: 20px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.skl-card__body {\n  padding: 20px;\n}\n\n.skl-card__body--actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.skl-table-wrap {\n  border: 1px solid #edf0f2;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.skl-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 0.8fr 1.4fr 1fr 0.8fr;\n}\n\n.skl-row--header {\n  background: #f8f9fa;\n}\n\n.skl-row--data + .skl-row--data {\n  border-top: 1px solid #edf0f2;\n}\n\n.skl-cell {\n  display: flex;\n  align-items: center;\n  min-height: 56px;\n  padding: 12px 16px;\n}\n\n.skl-records-stack {\n  display: flex;\n  flex-direction: column;\n}\n\n.skl-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 18px;\n}\n\n.skl-pagination-buttons {\n  display: flex;\n  gap: 4px;\n}\n\n@media (max-width: 991.98px) {\n  .skl-row {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 575.98px) {\n  .skl-card__body--actions,\n  .skl-pagination {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    gap: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
